// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".editQSQ .key {\n  color: #737373;\n  font-weight:bold;\n}\n.editQSQ .pair {\n  margin-bottom:8px;\n}\n.editQSQ label {\n  font-weight: normal;\n}", ""]);
// Exports
module.exports = exports;
